(() => {
  if (window.__gbSchoolEventsLoaded) return;
  window.__gbSchoolEventsLoaded = true;

  function analyticsAllowed() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }

  function emit(name, topic) {
    if (!analyticsAllowed() || !Array.isArray(window.dataLayer)) return;
    const payload = { event: name, school_section: 'ganbaru_coffee_school' };
    if (topic) payload.school_topic = topic;
    window.dataLayer.push(payload);
  }

  const page = document.querySelector('[data-gb-school-page]');
  const product = document.querySelector('.gb-product-main--course');
  let viewSent = false;
  function sendView() {
    if (viewSent || !analyticsAllowed()) return;
    if (product) { emit('course_view'); viewSent = true; }
    else if (page || document.querySelector('.gb-editorial--ganbaru-coffee-school')) {
      emit('school_view', page?.dataset.gbSchoolPage || 'school');
      viewSent = true;
    }
  }
  sendView();
  document.addEventListener('visitorConsentCollected', sendView);
  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-gb-school-event]');
    if (target) emit(target.dataset.gbSchoolEvent, target.dataset.gbSchoolTopic);
    if (event.target.closest('[data-gb-calendar-view], [data-gb-calendar-next], [data-gb-calendar-prev], [data-gb-calendar-filter]')) emit('calendar_open');
  });
  if (document.querySelector('[data-gb-lead-success]')) emit('lead_submit');
})();
